import React from "react";
import { RolloverContainer } from "../../../containers";

const Rollover = (props) => {
  return <RolloverContainer {...props} />;
};

export default Rollover;
